<template>
    <div class="sty-page grid grid__base u-typography-root">
        <div class="grid--container">
            <sty-header :facets="['main-title']">
                <sty-introduction/>
            </sty-header>
        </div>

        <div class="grid--container">
            <sty-menu :sections="sections"/>
        </div>

        <div class="sty-page--sections">
            <sass-data-provider provide="mq" v-slot="bridgeData">
                <sty-mq class="sty-page--section"
                        :bridge-data="bridgeData"
                        v-bind="sections.mq"/>
            </sass-data-provider>

            <sty-grid class="sty-page--section" v-bind="sections.grid"/>

            <sty-module-spacing class="sty-page--section" v-bind="sections.moduleSpacing"/>

            <sass-data-provider provide="colors" v-slot="bridgeData">
                <sty-colors class="sty-page--section"
                        :bridge-data="bridgeData"
                        v-bind="sections.colors"/>
            </sass-data-provider>

            <sass-data-provider provide="shadows" v-slot="bridgeData">
                <sty-shadows class="sty-page--section"
                        :bridge-data="bridgeData"
                        v-bind="sections.shadows"/>
            </sass-data-provider>

            <sass-data-provider provide="typo" v-slot="bridgeData">
                <sty-typo class="sty-page--section"
                        :bridge-data="bridgeData"
                        v-bind="sections.typo"/>
            </sass-data-provider>

            <sty-icons class="sty-page--section" v-bind="sections.icons"/>

            <sass-data-provider provide="buttons" v-slot="bridgeData">
                <sty-buttons class="sty-page--section"
                        :bridge-data="bridgeData"
                        v-bind="sections.buttons"/>
            </sass-data-provider>

            <sty-forms class="sty-page--section" v-bind="sections.forms"/>

            <sty-overlays class="sty-page--section" v-bind="sections.overlays"/>
        </div>
    </div>
</template>

<script>
    import SassDataProvider from 'framework/components/sass-data-provider/sass-data-provider';
    import StyHeader from 'framework/styleguide/header';
    import StyMenu from 'framework/styleguide/menu';
    import StyIntroduction from 'framework/styleguide/introduction';
    import StyMq from 'framework/styleguide/sections/mq';
    import StyGrid from 'framework/styleguide/sections/grid';
    import StyColors from 'framework/styleguide/sections/colors';
    import StyModuleSpacing from 'framework/styleguide/sections/module-spacing';
    import StyShadows from 'framework/styleguide/sections/shadows';
    import StyTypo from 'framework/styleguide/sections/typo';
    import StyIcons from 'framework/styleguide/sections/icons';
    import StyButtons from 'framework/styleguide/sections/buttons';
    import StyForms from 'framework/styleguide/sections/forms';
    import StyOverlays from 'framework/styleguide/sections/overlays';

    import sections from './sections';


    export default {
        components: {
            SassDataProvider,
            StyMenu,
            StyIntroduction,
            StyHeader,
            StyMq,
            StyGrid,
            StyColors,
            StyModuleSpacing,
            StyShadows,
            StyTypo,
            StyIcons,
            StyButtons,
            StyForms,
            StyOverlays,
        },
        data() {
            return { sections };
        },
    };
</script>
